import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { authApi, AuthResponse } from "redux/services/auth";
import env from "env";

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  expiresIn: number | null;
};

const INITIAL_STATE: AuthState = {
  accessToken: null,
  refreshToken: null,
  expiresIn: null,
};

export const refreshToken = createAsyncThunk<AuthResponse>(
  "auth/refreshToken",
  async (_, { getState }: any) => {
    const { refreshToken, accessToken } = getState().auth;

    const url = `${env.api.baseUrl.tokenBaseUrl}oauth2/token`;

    const body = new URLSearchParams();
    body.append("grant_type", "refresh_token");
    body.append("client_id", env.app.authCodeAppId);
    body.append("refresh_token", refreshToken);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: accessToken,
      },
      body,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const content = await response.json();
    return content;
  }
);


export const setTokens = createAction<AuthResponse>("auth/setTokens");

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    logout: () => INITIAL_STATE,
    setTokens: (state, { payload }) => {
      state.accessToken = payload.access_token;
      state.refreshToken = payload.refresh_token;
      state.expiresIn = payload.expires_in;
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(refreshToken.fulfilled, (state, { payload }) => {
      //   state.accessToken = payload.access_token;
      //   state.refreshToken = payload.refresh_token;
      //   state.expiresIn = payload.expires_in;
      // })
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          state.accessToken = payload.access_token;
          state.refreshToken = payload.refresh_token;
          state.expiresIn = payload.expires_in;
        }
      );
  },
});

export default authSlice.reducer;
export const { logout } = authSlice.actions;

export const selectAuth = (state: any) => state.auth;
